import React from 'react'
import { NavLink as Link, Link as RegularLink } from 'react-router-dom'
import utils from '../utils.js'

class Nav extends React.Component {

  constructor(props) {
    super(props)
    this.state = { currentTheme: this.getRandomTheme() }
  }
  layoutRoot
  themeSelector
  themes = [
    { name: "Burnt Sienna", value: "auburn", firstLoadOk:true },
    { name: "Terra", value: "terra", firstLoadOk: true},
    { name: "Console Shock", value: "consoleshock", firstLoadOk: true },
    { name: "Falcons (home)", value: "falconshome", firstLoadOk: false },
    { name: "Falcons (away)", value: "falconsaway", firstLoadOk: true },
    { name: "Hawks 2015", value: "hawks", firstLoadOk: false },
    { name: "Limeaid", value: "limeaid", firstLoadOk: true },
    { name: "Vanilla", value: "vanilla", firstLoadOk: true },
    { name: "Glaucous", value: "glaucous", firstLoadOk: false },
    { name: "Googl", value: "gooogle", firstLoadOk: true }, 
    { name: "Diet Coke", value: "dietcoke", firstLoadOk: true },
    { name: "Coca-Cola", value: "coke", firstLoadOk: false }, 
    { name: "t-shirt", value: "tshirt", firstLoadOk: false }, 
    { name: "Exposure", value: "polaroid", firstLoadOk: true }
  ]

  //mark root element (also the psp element) with the theme class:
  updateState = (ev) => {
    var theme = ev.target.value
    this.sendAnalyticsEvent(theme)
    this.setState((state) => {
      if (state && state.currentTheme) {
        this.layoutRoot.classList.remove(state.currentTheme)
        this.photoswipeEl.classList.remove(state.currentTheme)
      }
      this.layoutRoot.classList.add(theme)
      this.photoswipeEl.classList.add(theme)

      return { currentTheme: theme }
    })
    

  }
  componentDidMount() {
    //https://stackoverflow.com/questions/26059762/callback-when-dom-is-loaded-in-react-js
    //setTimeout(func, 0) also works.    
    window.addEventListener('load', (ev) => {
      this.layoutRoot = document.getElementById("layoutRoot")
      this.photoswipeEl = document.querySelector(".pswp")
      this.layoutRoot.classList.add(this.state.currentTheme)
      this.photoswipeEl.classList.add(this.state.currentTheme)
      this.themeSelector = document.getElementById("themeSelector")
    })
  }

  render() {
    return (

      <nav>
        <ul className="nav">
          <li><Link exact title="Home base of sweaverD.com" to="/"><span>Home</span></Link></li>
          <li><Link title="Skills,community, and experience" to="/code"><span>Code</span></Link></li>
          <li><Link title="Get to know me a little" to="/#aboutme" >About Me</Link></li>
          <li><Link to="/gallery" title="Photo gallery page">Gallery</Link></li>
          <li><Link to="/blog" title="Blog">Blog</Link></li>
          <li><Link title="Open source projects" to="/projects"><span>Projects</span></Link></li>
        </ul>
        {this.props.location.pathname === "/" ? (
          <div style={{ position: "relative" }}>
            <select id="themeSelector" title="Select the site theme." value={this.state.currentTheme} onChange={this.updateState}>
              {
                this.themes.map((item, i, arr) => {
                  return <option key={i} value={item.value}>{item.name}</option>
                })
              }
            </select>
          </div>
        ) : (
            <div id="miniLogo"><RegularLink to="/"><span>sweaverD.com</span></RegularLink></div>
          )
        }

      </nav>
    )
  }

  getRandomTheme = () => {
    
    var eligible = this.themes.filter(theme=>theme.firstLoadOk)
    var range = eligible.length
    var indexOfTheme = utils.getRandomInt(0, range)
    return eligible[indexOfTheme].value

  }

  sendAnalyticsEvent = (theme) => {
    console.log("Event (theme):" + theme)
    window.ga('send', {
      hitType: 'event',
      eventCategory: 'Theme',
      eventAction: 'change',
      eventLabel: theme
    });
  }
}
export default Nav